import * as types from "./actionTypes";

export const getRequest = id => {
  return {
    type: types.TICKET_SHOW_REQUEST,
    id
  };
};
export const getSuccess = data => {
  return {
    type: types.TICKET_SHOW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.TICKET_SHOW_FAILURE,
    error: error
  };
};

export const getListRequest = () => {
  return {
    type: types.TICKET_LIST_REQUEST
  };
};
export const getListSuccess = data => {
  return {
    type: types.TICKET_LIST_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.TICKET_LIST_FAILURE,
    error: error
  };
};

export const storeRequest = data => {
  return {
    type: types.TICKET_STORE_REQUEST,
    data: data
  };
};
export const storeSuccess = data => {
  return {
    type: types.TICKET_STORE_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.TICKET_STORE_FAILURE
  };
};

export const updateRequest = (id, data) => {
  return {
    type: types.TICKET_UPDATE_REQUEST,
    id: id,
    data: data
  };
};
export const updateSuccess = () => {
  return {
    type: types.TICKET_UPDATE_SUCCESS
  };
};
export const updateFailure = () => {
  return {
    type: types.TICKET_UPDATE_FAILURE
  };
};

export const modalData = data => {
  return {
    type: types.TICKET_MODAL_DATA,
    data
  };
};
export const closeModal = () => {
  return {
    type: types.TICKET_CLOSE_MODAL
  };
};
